import { lazyImport } from "../../utility/lazyImport";

const { Profile } = lazyImport(() => import("../../features/user"), "Profile");

const { Fide } = lazyImport(() => import("../../features/user"), "Fide");

const { Users } = lazyImport(() => import("../../features/user"), "Users");

const { ShowProfile } = lazyImport(
  () => import("../../features/user"),
  "ShowProfile"
);

// const History = lazy(() => import("../../pages/history"));
// const Verify = lazy(() => import("../../pages/verify"));
// const ShowProfile = lazy(() => import("../../pages/showProfile"));

const UserRoutes = [
  {
    path: "/profile",
    element: <Profile />,
  },
  // {
  //   path: "/profile/history",
  //   element: <History />,
  //   // meta: {
  //   //   publicRoute: true,
  //   //   action: "read",
  //   //   resource: "tournament",
  //   // },
  // },
  {
    path: "/fide",
    element: <Fide />,
    meta: {
      action: "fideverify",
      resource: "profile",
    },
  },
  {
    path: "/users",
    element: <Users />,
    meta: {
      action: "read",
      resource: "users",
    },
  },
  {
    path: "/profile/:id",
    element: <ShowProfile />,
    meta: {
      action: "show",
      resource: "profile",
    },
  },
];

export default UserRoutes;
